import { Grid, Typography } from '@mui/material'

const DetailItem = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: 'uppercase', fontWeight: 600 }}
    >
      {label}
    </Typography>
    <Typography variant="body1">{value || 'N/A'}</Typography>
  </Grid>
)

export default DetailItem
